module.exports = __webpack_public_path__ + "static/wagger-react-native-8396b10b407b27244234b5fc6d4d37a7.png";